import React, { useState, useEffect, useRef } from "react";
import { createSubscribeRequest } from "../actions/subscribersAction";
import { SUBSCRIBE_RESET } from "../constants/subscribersConstants";
import { useDispatch, useSelector } from "react-redux";
import emailjs from "emailjs-com";
import swal from "sweetalert";

const NewsletterPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    designation: "",
  });
  const [agreed, setAgreed] = useState(false);

  const dispatch = useDispatch();
  const form = useRef();

  const createSubscribe = useSelector((state) => state.createSubscribe);
  const {
    success: successRequest,
    loading: loadingRequest,
    error: errorRequest,
  } = createSubscribe;

    const [errorCreate1, seterrorCreate1] = useState(false);
  
    useEffect(() => {
        if (errorRequest) {
        seterrorCreate1(true);
        }
        setTimeout(() => {
        seterrorCreate1(false);
        }, 1000);
    }, [errorRequest]);

  useEffect(() => {
    // const timer = setTimeout(() => setIsVisible(true), 5000);
    // return () => clearTimeout(timer);
    const subscribed = localStorage.getItem("newsletterSubscribed");

    if (!subscribed) {
      const timer = setTimeout(() => setIsVisible(true), 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (successRequest) {
    swal({
      title: "Your have subscribed successfully!",
      icon: "success",
      button: "Close",
    });
  }

  if (errorCreate1) {
    swal({
      title: `${errorRequest}`,
      icon: "error",
      button: "Close",
    });
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    e.preventDefault(e);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agreed) {
      alert("Please agree to the Privacy Policy before subscribing.");
      // seterrorCreate1(true);
      return;
    }

    console.log("Subscribed Data:", formData);
    const { name, email, phone, company, designation } = formData;
    dispatch(createSubscribeRequest(name, email, phone, company, designation));
    // Send to Mailchimp, Microsoft Forms, backend, etc.
    setIsVisible(false);
  };

  useEffect(() => {
    if (successRequest === true) {
      setIsVisible(false);
      dispatch({
        type: SUBSCRIBE_RESET,
      });
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        designation: "",
      });
      setAgreed(false);

      // Save subscription state to localStorage
      localStorage.setItem("newsletterSubscribed", "true");

    }
  }, [dispatch, successRequest]);

  if (!isVisible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button
          style={styles.closeButton}
          onClick={() => setIsVisible(false)}
          aria-label="Close Newsletter Popup"
        >
          &times;
        </button>
        <h2>Get answers to your questions</h2>
        <p>
          Our clients turn to us to help them reimagine ways of working with technology.
        </p>

        <form ref={form} onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number (Optional)"
            value={formData.phone}
            onChange={handleChange}
            style={styles.input}
          />
          <input
            type="text"
            name="company"
            placeholder="Company Name"
            value={formData.company}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="text"
            name="designation"
            placeholder="Designation"
            value={formData.designation}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              required
              checked={agreed}
              onChange={() => setAgreed(!agreed)}
              style={{ marginRight: "0.5rem" }}
            />
            I agree to the {"  "}
            <a
              href="https://outcess.com/data-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0056b3", textDecoration: "underline" }}
            >
              Privacy Policy
            </a>
          </label>

          <button 
            type="submit" 
            style={styles.submitButton}
            disabled={loadingRequest && true}
          >
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "10px",
    width: "90%",
    maxWidth: "500px",
    maxHeight: "90vh", // Ensure the modal doesn't exceed viewport height
    // overflowY: "auto", // Allow scrolling if content is too long
    overflowY: "scroll", // enables scrolling
    scrollbarWidth: "none", // for Firefox
    msOverflowStyle: "none", // for IE and Edge
    position: "relative",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "15px",
    fontSize: "1.5rem",
    border: "none",
    background: "none",
    color: "red",
    cursor: "pointer",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginTop: "1rem",
  },
  input: {
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  submitButton: {
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#0056b3",
    color: "#fff",
    cursor: "pointer",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    fontSize: "0.9rem",
  },
};

export default NewsletterPopup;
